<template>
    <div class="fill-height background_image">
        <v-row
            no-gutters
            class="background_image d-flex d-flex justify-center"
            v-if="!$vuetify.display.mobile"
        >
            <v-col cols="1" />
            <v-col cols="10" class="d-flex justify-center py-6">
                <v-img :src="logo" height="70px" v-if="logo" />
                <div class="display-1 d-flex align-center" v-else style="height: 70px">
                    {{ currentUser.company.name }}
                </div>
            </v-col>
            <v-col cols="1" class="d-flex justify-end py-6 pr-6">
                <profile-menu />
            </v-col>
            <v-col cols="11" class="d-flex pt-6" style="height: calc(100vh - 156px)">
                <v-row no-gutters>
                    <v-col
                        cols="3"
                        class="px-3"
                        style="height: 85%; overflow: hidden"
                        @click="routerProd"
                    >
                        <v-hover v-slot:default="{ isHovering, props }">
                            <v-row v-bind="props" no-gutters class="fill-height">
                                <v-col cols="12" style="height: 100%; transition: all 280ms ease">
                                    <v-card
                                        elevation="0"
                                        class="rounded-lg pa-10 card-overlay"
                                        :class="isHovering ? 'hovering-card' : 'not-hovering-card'"
                                        ripple
                                    >
                                        <v-card-title class="card-text-title"
                                            >Production</v-card-title
                                        >

                                        <v-card-text
                                            class="card-text-description"
                                            style="min-height: 120px"
                                        >
                                            Collecte, traitement, saisie, révision, restitution
                                        </v-card-text>

                                        <v-col cols="12">
                                            <v-img
                                                src="img/bobbee3d/bobbee3d1.png"
                                                height="120px"
                                                width="100%"
                                                :class="
                                                    isHovering ? 'hovering-img' : 'not-hovering-img'
                                                "
                                            />
                                            <v-img
                                                height="15%"
                                                width="75%"
                                                style="left: 10%"
                                                src="img/production.png"
                                            />
                                        </v-col>
                                    </v-card>
                                </v-col>
                                <v-img
                                    src="img/bobbee3d/bobbee3d1.png"
                                    height="120px"
                                    style="position: absolute; top: 280px; left: 20px"
                                    :class="isHovering ? 'hovering-img' : 'not-hovering-img'"
                                />
                            </v-row>
                        </v-hover>
                    </v-col>
                    <v-col
                        cols="3"
                        class="px-3"
                        style="height: 85%; overflow: hidden"
                        @click="routeGed"
                    >
                        <v-hover v-slot:default="{ isHovering, props }">
                            <v-row v-bind="props" no-gutters class="fill-height">
                                <v-col cols="12" style="height: 100%; transition: all 280ms ease">
                                    <v-card
                                        elevation="0"
                                        class="rounded-lg pa-10 card-overlay"
                                        :class="isHovering ? 'hovering-card' : 'not-hovering-card'"
                                        ripple
                                    >
                                        <v-card-title class="card-text-title">GED</v-card-title>
                                        <v-card-text
                                            class="card-text-description"
                                            style="min-height: 120px"
                                        >
                                            DP, DA, DR, documents
                                        </v-card-text>
                                        <v-col cols="12">
                                            <v-img
                                                src="img/bobbee3d/bobbee3d2.png"
                                                height="140px"
                                                width="100%"
                                                :class="
                                                    isHovering ? 'hovering-img' : 'not-hovering-img'
                                                "
                                            />
                                            <v-img
                                                height="15%"
                                                width="75%"
                                                style="left: 10%"
                                                src="img/ged.png"
                                            />
                                        </v-col>
                                    </v-card>
                                </v-col>
                                <v-img
                                    src="img/bobbee3d/bobbee3d2.png"
                                    height="140px"
                                    style="position: absolute; top: 280px; left: 20px"
                                    :class="isHovering ? 'hovering-img' : 'not-hovering-img'"
                                />
                            </v-row>
                        </v-hover>
                    </v-col>

                    <v-col
                        cols="3"
                        class="px-3"
                        style="height: 85%; overflow: hidden"
                        @click="routeAdminHome"
                    >
                        <v-hover v-slot:default="{ isHovering, props }">
                            <v-row v-bind="props" no-gutters class="fill-height">
                                <v-col cols="12" style="height: 100%; transition: all 280ms ease">
                                    <v-card
                                        elevation="0"
                                        class="rounded-lg pa-10 card-overlay"
                                        :class="isHovering ? 'hovering-card' : 'not-hovering-card'"
                                        ripple
                                        data-cy="Homepage-gestionInterne"
                                    >
                                        <v-card-title data-cy="homepage-GI" class="card-text-title"
                                            >Gestion interne</v-card-title
                                        >
                                        <v-card-text
                                            class="card-text-description"
                                            style="min-height: 120px"
                                        >
                                            Equipe, dossiers, temps, Boni/Mali, facturation,
                                            déontologie
                                        </v-card-text>
                                        <v-col cols="12">
                                            <v-img
                                                src="img/bobbee3d/bobbee3d3.png"
                                                height="160px"
                                                width="100%"
                                                :class="
                                                    isHovering ? 'hovering-img' : 'not-hovering-img'
                                                "
                                            />
                                            <v-img
                                                height="15%"
                                                width="75%"
                                                style="left: 10%"
                                                src="img/gi.png"
                                            />
                                        </v-col>
                                    </v-card>
                                </v-col>
                                <v-img
                                    src="img/bobbee3d/bobbee3d3.png"
                                    height="160px"
                                    style="position: absolute; top: 280px; left: 20px"
                                    :class="isHovering ? 'hovering-img' : 'not-hovering-img'"
                                />
                            </v-row>
                        </v-hover>
                    </v-col>

                    <v-col
                        cols="3"
                        class="px-3"
                        style="height: 85%; overflow: hidden"
                        @click="routerDocumentation"
                    >
                        <v-hover v-slot:default="{ isHovering, props }">
                            <v-row v-bind="props" no-gutters class="fill-height">
                                <v-col cols="12" style="height: 100%; transition: all 280ms ease">
                                    <v-card
                                        elevation="0"
                                        class="rounded-lg pa-10 card-overlay"
                                        :class="isHovering ? 'hovering-card' : 'not-hovering-card'"
                                        ripple
                                    >
                                        <v-card-title class="card-text-title"
                                            >Les + de bobbee</v-card-title
                                        >
                                        <v-card-text
                                            class="card-text-description"
                                            style="min-height: 120px"
                                        >
                                            Articles, blog, forum
                                        </v-card-text>
                                        <v-col cols="12">
                                            <v-img
                                                src="img/bobbee3d/bobbee3d1.png"
                                                height="120px"
                                                width="100%"
                                                :class="
                                                    isHovering ? 'hovering-img' : 'not-hovering-img'
                                                "
                                            />
                                            <v-img
                                                height="15%"
                                                width="75%"
                                                style="left: 10%"
                                                src="img/lesplusbobbee.png"
                                            />
                                        </v-col>
                                    </v-card>
                                </v-col>
                                <v-img
                                    src="img/bobbee3d/bobbee3d1.png"
                                    height="120px"
                                    style="position: absolute; top: 280px; left: 20px"
                                    :class="isHovering ? 'hovering-img' : 'not-hovering-img'"
                                />
                            </v-row>
                        </v-hover>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="d-flex align-center pb-2 pr-2 justify-start">
                Powered by <img src="img/bobbee_hrz.png" height="30px" class="mb-1 ml-1" />
            </v-col>
        </v-row>
        <v-row no-gutters class="background_image d-flex d-flex justify-center fill-height" v-else>
            <v-col cols="2" />
            <v-col cols="8" class="d-flex justify-center py-6">
                <v-img :src="logo" height="50px" v-if="logo" />
                <div class="display-1 d-flex align-center" v-else style="height: 70px">
                    {{ currentUser.company.name }}
                </div>
            </v-col>
            <v-col cols="2" class="d-flex justify-end py-6 pr-6">
                <profile-menu />
            </v-col>
            <v-col cols="12">
                <v-list style="background: transparent">
                    <v-list-item
                        v-for="(item, index) in sections"
                        :key="index"
                        ripple
                        class="ma-1"
                        @click="item.route()"
                    >
                        <v-list-item-title>
                            {{ item.title }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ item.subtitle }}
                        </v-list-item-subtitle>
                        <template v-slot:append>
                            <v-icon>$chevron_right</v-icon>
                        </template>
                    </v-list-item>
                </v-list>
            </v-col>
            <v-col cols="12" class="d-flex justify-end align-end pr-2 pb-2">
                Powered by <v-img src="img/bobbee_hrz.png" height="25px" class="mb-1 ml-1 mr-3" />
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { User } from "../store/store";

import ACCOUNTING_COMPANY_OF_COMPANY from "../graphql/company/AccountingCompanyOfCompany.gql";

import ProfileMenu from "./auth/ProfileMenu.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { logOutUser } from "@/services/userServices";

@Component({
    components: {
        ProfileMenu,
    },
})
export class AccountantHomePage extends Vue {
    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get logo() {
        if (
            this.isAccountingUser &&
            this.currentUser &&
            this.currentUser.company &&
            this.currentUser.company.logo &&
            this.currentUser.company.logo.signedUrl
        ) {
            return this.currentUser.company.logo.signedUrl;
        }
        if (
            !this.isAccountingUser &&
            this.accountingFirm &&
            this.accountingFirm.logo &&
            this.accountingFirm.logo.signedUrl
        ) {
            return this.accountingFirm.logo.signedUrl;
        }
        return null;
    }

    get sections() {
        return [
            {
                title: "Production",
                subtitle: "Collecte, traitement, saisie, révision, restitution",
                route: () => {
                    this.routerProd();
                },
            },
            {
                title: "GED",
                subtitle: "DP, DA, DR, documents",
                route: () => {
                    this.routeGed();
                },
            },
            {
                title: "GI",
                subtitle: "Equipe, dossiers, temps, Boni/Mali, facturation, déontologie",
                route: () => {
                    this.routeAdminHome();
                },
            },
            {
                title: "Les + de bobbee",
                subtitle: "Articles, blog, forum",
                route: () => {
                    this.routerDocumentation();
                },
            },
        ];
    }

    @Apollo({
        query: ACCOUNTING_COMPANY_OF_COMPANY,
        variables() {
            return {
                companyId: this.currentUser.company.id,
            };
        },
        skip() {
            return !this.currentUser.id || this.isAccountingUser;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companies && data.companies.length) {
                    this.accountingFirm = data.companies[0];
                }
            }
        },
    })
    accountingFirm = null;

    routeGed() {
        this.$router.push({ name: "documents" });
    }

    routeAdminHome() {
        this.$router.push({ name: "my-companies-edition", params: { type: "company" } });
    }

    routerProd() {
        this.$router.push({
            name: "accountingClients",
            params: {
                mode: "Production",
            },
        });
    }

    routerDocumentation() {
        document.location.href = "https://bobbee.co/Le-blog";
    }

    logout() {
        // this.$store.commit("logoutUser");
        logOutUser(this.$store, this.$router);
    }
}

export default toNative(AccountantHomePage);
</script>
<style>
.card-text-title {
    font-size: 1rem;
}

.card-text-description {
    font-size: 0.8rem;
}
.background_image {
    background-size: cover;
    background-attachment: fixed;
    background-color: #f4f4f4;
}

.background-card-1 {
    background: url("../assets/img/cog-solid.svg");
    background-size: 30%;
    background-repeat: no-repeat;
    background-position: center;
}

.background-card-2 {
    background: url("../assets/img/wrench-solid.svg");
    background-size: 30%;
    background-repeat: no-repeat;
    background-position: center;
}

.background-card-3 {
    background: url("../assets/img/pen-solid.svg");
    background-size: 30%;
    background-repeat: no-repeat;
    background-position: center;
}

.background-card-4 {
    background: url("../assets/img/newspaper-regular.svg");
    background-size: 30%;
    background-repeat: no-repeat;
    background-position: center;
}

.bottom-image {
    position: absolute;
    bottom: 0;
    padding-bottom: 10%;
    align-items: center;
}

.hovering-card {
    transition: all 280ms ease;
    background-color: rgba(253, 227, 178, 0.2);
    height: 100%;
    border: 2px solid #edac50;
    position: relative;
    overflow: hidden;
}

.not-hovering-card {
    height: 100%;
    position: relative;
    overflow: hidden;
}

.hovering-img {
    opacity: 1;
    transition: all 280ms ease;
    position: absolute;
    z-index: 1000;
    bottom: 50%;
}

.not-hovering-img {
    opacity: 0;
    transition: all 280ms ease;
    position: absolute;
    z-index: 1000;
    bottom: 50%;
}
</style>
